import React from 'react'
import "./HomeApproachText.css"
import ServicesApproachCarasoul from '../ServicesApproachCarasoul/ServicesApproachCarasoul'


function HomeApproachText() {
  return (
    <div className='HomeApproachText-container standard-padding-space'>
        <div className='container'>
            <div className='text-content text-lg-start text-center'>
                <h3 className='main-heading'>A <span className='blue-txt'>Holistic</span> Approach to Your Health</h3>
                <p className='body-paragraph'>Discover our full suite of integrative services, designed to complement your membership and support your health journey with precision and ease. From diagnostics to therapeutics, everything is thoughtfully delivered under one roof.</p>

            </div>

        </div>
            <div style={{overflowX:"hidden"}}>
             <div className='mt-5 slider-container'>
                <ServicesApproachCarasoul
                />

            </div>
            </div>
    </div>
  )
}

export default HomeApproachText